import React from 'react';
import './index.scss';

function PlatformName(props) {
  const { loginInfo } = props;
  return (
    <div>
      <div className='platform-title'>
        <div className='platform-title-text'>
          <div>{loginInfo?.name}</div>
        {loginInfo?.en_name ? <div style={{ textAlign: 'justify',color: 'white',fontSize: 12,letterSpacing: 0, marginTop: 5 }}>{loginInfo?.en_name}</div> : null}</div>
      </div>
    </div>
  )
}

export default PlatformName;